import React from 'react';
import classes from './CountrySelect.module.scss';

const CountrySelect = ({ countries, value, onChange, className }) => {
  if (!countries || countries.length <= 1) return null;

  return (
    <select
      value={value ?? ''}
      onChange={(e) => onChange(e.target.value)}
      className={`${classes.CountrySelect}${className ? ` ${className}` : ''}`}
    >
      <option value="">All Countries</option>
      {countries.map((c) => (
        <option key={c} value={c}>
          {c}
        </option>
      ))}
    </select>
  );
};

export default CountrySelect;
